import { render } from "./GabineteAgendaTipoSelect.vue?vue&type=template&id=a3647dd4"
import script from "./GabineteAgendaTipoSelect.vue?vue&type=script&lang=js"
export * from "./GabineteAgendaTipoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__